import styles from './LastViewedProduct.module.scss'
import { useGetBasicProduct } from '../catalog/ProductPage/GetBasicProduct.query'
import Loader from '../presentation/Loader'
import ProductCard from '../presentation/ProductCard'

interface Props {
    index?: number
    productId: number
}

export const LastViewedProduct = ({ index, productId }: Props) => {
    const { data: product, loading } = useGetBasicProduct(productId ?? '')

    if (loading) {
        return <Loader />
    }

    if (!product) {
        return null
    }

    return (
        <div className={styles.container}>
            <ProductCard
                product={product}
                withBookmark
                initialValue={undefined}
                withColorSwatch={false}
                position="lastviewed"
                itemListId={`${index}` ?? ''}
                itemListName=""
                itemListSlot=""
                itemIndex={index ?? 0}
            />
        </div>
    )
}
